'use strict';

angular.module('shiftTraderApp')
    .directive('saNoteQueryBoxPills', ['$compile', '$controller', 'PositionsStore', 'UsersStore', 'WorkPeriodStore', '$q', function ($compile, $controller, PositionsStore, UsersStore, WorkPeriodStore, $q) {
      return {
        restrict: 'A',
        link: function (scope, elem) {
          var baseCtrl = $controller('BaseQuerySubscriptionCtrl', {$scope: scope});

          function compile(pills) {
            var html = '<div class="sa-note-query-box-pills">';

            lodash.each(pills, function(pill) {
              html += '<div class="note-relation-pill">';
              html += '<div class="remove" ng-click="removePill(\'' + pill.removeType + '\')" style="display:inline-block;"><i class="icon-remove"></i></div> ';
              html += '<div class="pill-text">' + pill.text + '</div></div>';
            });
            html += '</div>';

            $(elem).html($compile(html)(scope));
          }

          function retrieveObject(obj, obj_id) {
            var deferred = $q.defer();

            if (obj === 'Position') {
              PositionsStore.getRecordById(obj_id)
                .then(function(position) {
                  deferred.resolve(position);
                }, function(response) {
                  deferred.reject(response);
                });
            } else if (obj === 'User') {
              UsersStore.getRecordById(obj_id)
                .then(function(user) {
                  user.name = user.first_name + ' ' + user.last_name;
                  deferred.resolve(user);
                }, function(response) {
                  deferred.reject(response);
                });

            } else if (obj === 'WorkPeriod') {
              WorkPeriodStore.getRecordById(obj_id)
                .then(function(wp) {
                  wp.name = wp.position.name + ' Shift: ' + wp.start_time.format('MM/DD') + ' @ ' + wp.start_time.format('hh:mm');
                  deferred.resolve(wp);
                }, function(response) {
                  deferred.reject(response);
                });
            }

            return deferred.promise;
          }

          scope.removePill = _.throttle(function(type) {
            var q = baseCtrl.getQuery();

            if (type === 'dates') {
              q.dates.start = null;
              q.dates.end = null;
            } else if (type === 'obj') {
              q.obj = 'date';
              q.obj_id = null;
            } else if (type === 'created_by') {
              delete q.created_by;
            } else if (type === 'replied_by') {
              delete q.created_by;
              delete q.replies_only;
            } else if (_.contains(type, 'tag')) {
              var split = type.split('-');
              var index = _.indexOf(q.tags, split[1]);
              q.tags.splice(index, 1);
            }

            baseCtrl.setQuery(q);
          }, 250);

          function parsePills(query) {
            var pills = [];
            var deferred = $q.defer();

            var promises = [];

            if (query.created_by) {
              promises.push(retrieveObject('User', query.created_by)
                .then(function(user) {
                  if (query.replies_only) {
                    pills.push({
                      text: 'Replied by ' + user.first_name + ' ' + user.last_name,
                      removeType: 'replied_by'
                    });
                  } else {
                    pills.push({
                      text: 'Created by ' + user.first_name + ' ' + user.last_name,
                      removeType: 'created_by'
                    });
                  }
                }, function(response) {
                  console.log('Failed to retrieveObject()', response);
                }));
            }

            if (query.dates && query.dates.start && query.dates.end) {
              if (query.dates.start.format('MM/DD') === moment(query.dates.end).subtract(12, 'hours').format('MM/DD')) {
                pills.push({
                  text: 'On ' + query.dates.start.format('MM/DD'),
                  removeType: 'dates'
                });
              } else {
                pills.push({
                  text: 'Between ' + query.dates.start.format('MM/DD') + ' and ' + moment(query.dates.end).subtract(12, 'hours').format('MM/DD'),
                  removeType: 'dates'
                });
              }
            }

            if (query.obj && query.obj_id) {
              promises.push(retrieveObject(query.obj, query.obj_id)
                .then(function(obj) {
                  pills.push({
                    text: ((query.obj === 'WorkPeriod') ? '' : query.obj + ': ') + obj.name,
                    removeType: 'obj'
                  });
                }, function(response) {
                  console.log('Failed to retrieveObject()', response);
                }));
            } else if (query.obj && (query.obj === 'Position' || query.obj === 'User' || query.obj === 'WorkPeriod')) {
              pills.push({
                text: 'Attached to all ' + query.obj + 's',
                removeType: 'obj'
              });
              deferred.resolve(pills);
            }

            if (query.tags && !_.isEmpty(query.tags)) {
              _.each(query.tags, function(tag) {
                pills.push({
                  text: '#' + tag,
                  removeType: 'tag-' + tag
                });
              });
            }

            $q.all(promises)
              .then(function() {
                deferred.resolve(pills);
              }, function(response) {
                deferred.reject(response);
              });

            return deferred.promise;
          }

          function render(query) {
            parsePills(query)
              .then(function(pills) {
                compile(pills);
              }, function(res) {
                console.log('Failed to parsePills()', res);
              });
          }

          // Base ctrl
          baseCtrl.initialize('QueryBoxPills', scope.managementId);
          baseCtrl.setRenderCallback(render);
          baseCtrl.updateMyself();
        }
      }
    }]);
